<template>
	<div class="tree">
		<ul class="tree-list"> 
			<re-node-tree 
					v-for="n in treeData"
					v-bind:key="n.name"
					:node="n"
					:parent="n"
					:NotFolderClick="NotFolderClick"
					:curentpath="curentpath"
					:CurentDeep="0"
					:treeIndexFiltered="treeIndexFiltered"
					:treeIndexFilteredStr="treeIndexFilteredStr"
					:filter_str="filter_str"
					:SubFilterBtnClick="SubFilterBtnClick"
					:OverightAllClick="OverightAllClick"
					:keyFilter="keyFilter"
					:AddStyleFilter="AddStyleFilter"
			> 
			</re-node-tree>
		</ul>
	</div>
</template>

<script>
  import ReNodeTree from "./ReNodeTree.vue";
  export default {
    name: 'ReTree',
    data () {
		return {
		    ver: 1.1,
		    content: this.value,
		}
    },
    components: {
		ReNodeTree,
    },
    computed: {
		treeIndexFiltered:function(){
			if(this.filter_str.length > this.MinFilterLen){
				let LocalIndex = [];
				let LocalIndexFiltered = [];
				this.$GVO.CreateIndexReq(this.treeData,'',LocalIndex);
				for(let i in LocalIndex){
					let tmp1=i.toLocaleUpperCase().split(' => ').slice(-1); //console.log(tmp1);
					if(tmp1.toLocaleString().indexOf(this.filter_str.toLocaleUpperCase()) > -1){ //console.log(this.keyFilter); 
						if(this.keyFilter == undefined || (LocalIndex[i]!=undefined && LocalIndex[i][this.keyFilter.key] == this.keyFilter.val)){
							LocalIndexFiltered[i]=LocalIndex[i];
						}
					}
				} //console.log(LocalIndexFiltered);
				return LocalIndexFiltered;
			}else{
				return [];
			}
		},
		treeIndexFilteredStr(){
			let r = '###';
			for(let i in this.treeIndexFiltered){
				r+=i+'###';
			}
			return r.toLocaleUpperCase();
		},
    },
    props: {
		treeData: Array,
		NotFolderClick: Function,
		curentpath: Array,
		filter_str: { type:String, default:'' },
		MinFilterLen: {type:Number, default:2 },
		SubFilterBtnClick: {type:Function, default:undefined },	
		OverightAllClick: Function,	
		keyFilter:Object,
		AddStyleFilter: {
			type: Object,
			default() {	return {}; }
		},
    },
    watch: {

    },
    methods: {

    },
}
</script>
<style>
    .tree-list ul {
		padding-left: 16px;
		margin: 6px 0;
    }
    .NotFolder .Curent{
        color: #ef8157;
    }
</style>
